// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { pdfjs } from "react-pdf";
import { ToastContainer } from "react-toastify";

import LoginCard from "./components/LoginCard.js";
import Config from "./Config.js";
import Layout from "./components/Layout.js";

import PageNotFound from "./components/pageNotFound/PageNotFound.js";
import RequireAuth from "./routers/RequireAuth.js";
import Footer from "./components/Footer.js";
import TicketLayout from "./components/layout/TicketLayout.js";
import AssignTicket from "./components/AssignTicket.js";
import ViewTicket from "./components/ViewTicket.js";

import "react-toastify/dist/ReactToastify.css";
import AssigneeHistory from "./components/AssigneeHistory.js";
import ChangeAssignee from "./components/ChangeAssignee.js";
import CompleteWorkflowModal from "./components/CompleteWorkflowModal.js";

import HomePage from "./components/home/HomePage.js";
import DocumentException from "./components/DocumentException.js";
import RoleDetail from "./components/roleDetail/RoleDetail.js";
import Role from "./pages/role/Role.js";
import Users from "./pages/user/User.js";
import AdminAuth from "./routers/AdminAuth.js";
import AdminLayout from "./components/layout/AdminLayout.js";
import CreateSmcTicket from "./components/CreateSmcTicket/CreateSmcTicket";


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url
).toString();
const App = ({ isSignedIn, token }) => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path={"/login"} element={<LoginCard />} />

          <Route
            path={"/"}
            element={
              <RequireAuth isSignedIn={isSignedIn}>
                <HomePage />
              </RequireAuth>
            }
          />

          <Route
            path={"/admin"}
            element={
              <AdminAuth isSignedIn={isSignedIn}>
                <AdminLayout />
              </AdminAuth>
            }
          >
            <Route path={"/admin/users"} element={<Users token={token} />} />
            <Route path={"/admin/roles"} element={<Role />} />
            <Route path={"/admin/roles/:role"} element={<RoleDetail />} />
            <Route path={"*"} element={<PageNotFound slug="/admin/users" />} />
          </Route>

          <Route
            path={"/manage-ticket"}
            element={
              <RequireAuth isSignedIn={isSignedIn}>
                <Layout token={token} />
              </RequireAuth>
            }
          />

          <Route
            path={"/manage-ticket/create-smc"}
            element={
              <RequireAuth isSignedIn={isSignedIn}>
                <CreateSmcTicket />
              </RequireAuth>
            }
          />

          <Route
            path={"/document-exception"}
            element={
              <RequireAuth isSignedIn={isSignedIn}>
                <DocumentException token={token} />
              </RequireAuth>
            }
          />

          <Route
            path={"/manage-ticket/ticket"}
            element={
              <RequireAuth isSignedIn={isSignedIn}>
                <TicketLayout />
              </RequireAuth>
            }
          >
            <Route
              path={"/manage-ticket/ticket/edit/:id"}
              element={<AssignTicket />}
            />
            <Route
              path={"/manage-ticket/ticket/view/:id"}
              element={<ViewTicket />}
            />            
            <Route
              path={"/manage-ticket/ticket/edit/:id/assignee-history"}
              element={<AssigneeHistory />}
            />
            <Route
              path={"/manage-ticket/ticket/edit/:id/change-assignee"}
              element={<ChangeAssignee />}
            />
                        <Route
              path={"/manage-ticket/ticket/complete-workflow/:id"}
              element={<CompleteWorkflowModal />}
            />

            {/* <Route
              path={"*"}
              element={<PageNotFound slug="/dashboard/users" />}
            /> */}
          </Route>

          <Route path={"*"} element={<PageNotFound slug="/" />} />
        </Routes>
      </BrowserRouter>
      <Footer />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default App;
